var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_10583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 4C19.1144 6.75543 23.1792 8.19009 27.3333 8C27.9381 10.0574 28.1231 12.2153 27.8774 14.3456C27.6318 16.4759 26.9604 18.535 25.9031 20.4007C24.8459 22.2664 23.4245 23.9005 21.7232 25.206C20.022 26.5114 18.0757 27.4616 15.9999 28C13.9242 27.4616 11.9779 26.5114 10.2767 25.206C8.57542 23.9005 7.15395 22.2664 6.09674 20.4007C5.03952 18.535 4.36812 16.4759 4.12244 14.3456C3.87676 12.2153 4.06182 10.0574 4.66661 8C8.82065 8.19009 12.8855 6.75543 15.9999 4Z",
    stroke: "#00A68B",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4V28",
    stroke: "#00A68B",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.6667H27.8667",
    stroke: "#00A68B",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.6667H27.8667",
    stroke: "#00A68B",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.66675H20.1333",
    stroke: "#00A68B",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.6667H24.2667",
    stroke: "#00A68B",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.6667H26.6667",
    stroke: "#00A68B",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_10583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.3057fcc7.svg";
export { ForwardRef as ReactComponent };